export default "__VITE_ASSET__DGVm5G9j__"